import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; 
const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '918129057122';
    const message = 'Hello, I have a question about your services';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div id="whatsappFloat" onClick={handleWhatsAppClick}>
      <FaWhatsapp className="whatsappIcon" />
    </div>
  );
};

export default WhatsAppButton;